const STATS = [
  { icon: "ri-list-check-2", value: "23", label: "复盘关键节点", desc: "起因到结局全收录" },
  { icon: "ri-chat-heart-line", value: "12.6w", label: "全网参与讨论", desc: "围观与站队总人次", tone: "accent" },
  { icon: "ri-star-smile-line", value: "9", label: "高光名场面", desc: "被反复回味的瞬间" },
  { icon: "ri-discuss-line", value: "5", label: "收尾讨论方向", desc: "仍在持续发酵的话题" },
];

export default function StatsBar() {
  return (
    <section aria-label="数据速览" className="border-b border-background-200 bg-background-50">
      <div className="page-shell grid grid-cols-1 gap-3 py-10 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s) => (
          <div
            key={s.icon}
            className="flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100/70 px-5 py-5"
          >
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-2xl ${
                s.tone === "accent"
                  ? "bg-accent-500 text-background-50"
                  : "bg-primary-100 text-primary-600"
              }`}
            >
              <i className={s.icon} aria-hidden="true" />
            </span>
            <div>
              <div className={`font-display text-3xl leading-none ${s.tone === "accent" ? "text-accent-700" : "text-foreground-950"}`}>
                {s.value}
              </div>
              <div className="mt-1 text-sm font-bold text-foreground-900">{s.label}</div>
              <div className="text-xs text-foreground-600">{s.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}